import { BaseEvent } from "@infrastructure/Events/EventBus";

export const USER_ACTIVATION_START = "start-activation";

export type StartActivationEvent = BaseEvent & {
    cancel?: () => void;
    success?: () => void;
};
